export enum CARD_TYPE {
    GIFT_CODE = "gift_code",
    MOVIECARD = "moviecard",
    CINEFAN = "cinefan",
    TICKETCARD = "ticketcard",
}